import React, { useState, useEffect } from "react";
import { Drawer, Button, Badge } from "antd";
import { MessageOutlined, CloseOutlined, LeftOutlined } from "@ant-design/icons";
import ChatList from "./ChatList";
import ChatWindow from "./ChatWindow";
import { chatService } from "../../services/chatService";
import { useTranslation } from "react-i18next";

const ChatDrawer = () => {
  const { t } = useTranslation();
  const userId = parseInt(localStorage.getItem("id"));
  const userName = localStorage.getItem("user");

  const [open, setOpen] = useState(false);
  const [activeChat, setActiveChat] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);

  const toggleDrawer = () => {
    setOpen(!open);
    if (open) {
      chatService.updatePresence(userId, null);
    }
  };

  useEffect(() => {
    if (activeChat && open) {
      chatService.updatePresence(userId, activeChat.id);
      chatService.markAsRead(activeChat.id, userId);
    }
  }, [activeChat, open, userId]);

  useEffect(() => {
    if (!userId) return;
    const unsubscribe = chatService.subscribeToChats(userId, (chats) => {
      let count = 0;
      chats.forEach(chat => {
        if (chat.lastMessage && !chat.lastMessage.readBy.includes(userId)) {
          count++;
        }
      });
      setUnreadCount(count);
    });
    return () => unsubscribe();
  }, [userId]);

  const getChatTitle = () => {
    if (!activeChat) return t("chat.title", "Chats");
    if (activeChat.isGroup) return activeChat.groupName;
    const otherId = Object.keys(activeChat.participantsData).find(id => id != userId);
    return activeChat.participantsData[otherId]?.name || t("chat.conversation", "Conversation");
  };

  return (
    <>
      <div className="fixed bottom-6 right-6 z-50">
        <Badge count={unreadCount} offset={[-5, 5]} style={{ backgroundColor: '#3073f1' }}>
          <Button
            type="primary"
            shape="circle"
            icon={<MessageOutlined />}
            size="large"
            onClick={toggleDrawer}
            className="shadow-xl bg-[#3073f1] hover:scale-110 transition-transform"
            style={{ width: 60, height: 60, fontSize: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          />
        </Badge>
      </div>

      <Drawer
        title={
          <div className="flex items-center justify-between w-full pr-4">
            <div className="flex items-center gap-2">
              {activeChat && (
                <Button
                  type="text"
                  icon={<LeftOutlined />}
                  onClick={() => setActiveChat(null)}
                  className="mr-1"
                />
              )}
              <span className="font-semibold text-lg">{getChatTitle()}</span>
            </div>
          </div>
        }
        placement="right"
        onClose={toggleDrawer}
        open={open}
        width={window.innerWidth < 450 ? "100%" : 400}
        bodyStyle={{ padding: 0, display: "flex", flexDirection: "column" }}
        headerStyle={{ padding: "12px 16px" }}
        closable={true}
        closeIcon={<CloseOutlined className="text-gray-500" />}
      >
        {activeChat ? (
          <ChatWindow
            chat={activeChat}
            userId={userId}
            userName={userName}
            onBack={() => setActiveChat(null)}
          />
        ) : (
          <ChatList
            userId={userId}
            onChatSelect={setActiveChat}
          />
        )}
      </Drawer>
    </>
  );
};

export default ChatDrawer;
